import React from 'react';
import {
  AZQP_CA_PROVINCES,
  AZQP_COUNTY_ABBREVS,
  AZQP_ENTRY_CATEGORY_OPTIONS,
  AZQP_MODE_CATEGORY_OPTIONS,
  AZQP_POWER_OPTIONS,
  AZQP_STATION_CATEGORY_OPTIONS,
  AZQP_US_STATES,
  validateAzqpExchange
} from './azqpRules';

function AzqpStationSettingsFields({ settings, updateField }) {
  return (
    <>
      <section className="settings-section">
        <h2>Station Identity</h2>
        <div className="settings-fields">
          <label>
            Entry Callsign
            <input
              type="text"
              value={settings.callsign || ''}
              onChange={(e) => updateField('callsign', e.target.value.toUpperCase())}
              placeholder="e.g., W7ZZ"
              maxLength={12}
            />
          </label>

          <label className="bonus-item">
            <input
              type="checkbox"
              checked={Boolean(settings.isArizonaStation)}
              onChange={(e) => updateField('isArizonaStation', e.target.checked)}
            />
            <span className="bonus-label">Arizona station (send AZ county in exchange)</span>
          </label>

          <label>
            Sent Exchange Location
            <input
              type="text"
              value={settings.sentLocation || ''}
              onChange={(e) => updateField('sentLocation', e.target.value.toUpperCase())}
              placeholder={settings.isArizonaStation ? 'e.g., MCP' : 'e.g., WA'}
              list="azqp-sent-location-list"
            />
            <datalist id="azqp-sent-location-list">
              {(settings.isArizonaStation ? AZQP_COUNTY_ABBREVS : [...AZQP_US_STATES, ...AZQP_CA_PROVINCES]).map((code) => (
                <option key={code} value={code} />
              ))}
            </datalist>
            <span className="field-hint">
              AZ stations send a 3-letter county. Others send a 2-letter state or province.
            </span>
          </label>

          <label>
            Default Sent RST
            <input
              type="text"
              value={settings.defaultSentRst || '59'}
              onChange={(e) => updateField('defaultSentRst', e.target.value)}
              placeholder="59"
              maxLength={3}
            />
          </label>
        </div>
      </section>

      <section className="settings-section">
        <h2>Entry Category</h2>
        <div className="settings-fields">
          <label>
            Operator Category
            <select
              value={settings.entryCategory || 'SINGLE-OP'}
              onChange={(e) => updateField('entryCategory', e.target.value)}
            >
              {AZQP_ENTRY_CATEGORY_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </label>

          <label>
            Mode Category
            <select
              value={settings.modeCategory || 'MIXED'}
              onChange={(e) => updateField('modeCategory', e.target.value)}
            >
              {AZQP_MODE_CATEGORY_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </label>

          <label>
            Power Level
            <select
              value={settings.powerLevel || 'LOW'}
              onChange={(e) => updateField('powerLevel', e.target.value)}
            >
              {AZQP_POWER_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </label>

          <label>
            Station Category
            <select
              value={settings.stationCategory || 'FIXED'}
              onChange={(e) => updateField('stationCategory', e.target.value)}
            >
              {AZQP_STATION_CATEGORY_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </label>

          <label className="bonus-item">
            <input
              type="checkbox"
              checked={Boolean(settings.k7aBonusClaimed)}
              onChange={(e) => updateField('k7aBonusClaimed', e.target.checked)}
            />
            <span className="bonus-label">Claim K7A bonus (+100 points)</span>
          </label>
        </div>
      </section>
    </>
  );
}

export function validateAzqpStationSettings(settings) {
  const normalized = settings || {};
  if (normalized.sentLocation && !validateAzqpExchange(normalized.sentLocation)) {
    return 'Sent exchange location must be a valid AZ county, state, or province.';
  }
  return '';
}

export default AzqpStationSettingsFields;
